import {
  Exceptiondt2hlxn7j7vw as Exception,
  VOID7hggqo3abtya as VOID,
  Exception_init_$Init$2fx1sms2m4tu1 as Exception_init_$Init$,
  captureStack1fzi4aczwc4hg as captureStack,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  Unit_instance104q5opgivhr8 as Unit_instance,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  equals2au1ep9vhcato as equals,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  isInterface3d6p8outrmvmk as isInterface,
  hashCodeq5arwsb9dgti as hashCode,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Charsets_getInstancemd62gu5po4os as Charsets_getInstance,
  forName2faodmskqnoz5 as forName,
  isSupported2nf870ypy50et as isSupported,
} from './ktor-ktor-io.mjs';
import {
  HttpHeaders_getInstancekqele34vb34f as HttpHeaders_getInstance,
  parseAndSortHeader33xgq5fx7y6j1 as parseAndSortHeader,
  NullBody_instance9oj4j8z4op1j as NullBody_instance,
} from './ktor-ktor-http.mjs';
import {
  FlowCollector26clgpmzihvke as FlowCollector,
  asFlow3ngsnn5xpz8pw as asFlow,
  firstOrNull3pfaj04seehr5 as firstOrNull,
} from './kotlinx-coroutines-core.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForClass(ContentConvertException, 'ContentConvertException', VOID, Exception);
initMetadataForClass(JsonConvertException, 'JsonConvertException', VOID, ContentConvertException);
function register$default(contentType, converter, configuration, $super) {
  var tmp;
  if (configuration === VOID) {
    tmp = Configuration$register$lambda;
  } else {
    tmp = configuration;
  }
  configuration = tmp;
  var tmp_0;
  if ($super === VOID) {
    this.f4n(contentType, converter, configuration);
    tmp_0 = Unit_instance;
  } else {
    tmp_0 = $super.f4n.call(this, contentType, converter, configuration);
  }
  return tmp_0;
}
initMetadataForInterface(Configuration, 'Configuration');
initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
initMetadataForLambda(deserialize$o$collect$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($collectCOROUTINE$1, CoroutineImpl);
initMetadataForClass(deserialize$$inlined$map$1, VOID, VOID, VOID, VOID, [1]);
initMetadataForLambda(deserialize$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($deserializeCOROUTINE$0, CoroutineImpl);
//endregion
function ContentConvertException(message, cause) {
  cause = cause === VOID ? null : cause;
  Exception_init_$Init$(message, cause, this);
  captureStack(this, ContentConvertException);
}
function JsonConvertException(message, cause) {
  cause = cause === VOID ? null : cause;
  ContentConvertException.call(this, message, cause);
  captureStack(this, JsonConvertException);
}
function deserialize(_this__u8e3s4, body, typeInfo, charset, $completion) {
  var tmp = new $deserializeCOROUTINE$0(_this__u8e3s4, body, typeInfo, charset, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function suitableCharset(_this__u8e3s4, defaultCharset) {
  defaultCharset = defaultCharset === VOID ? Charsets_getInstance().n3n_1 : defaultCharset;
  var tmp0_elvis_lhs = suitableCharsetOrNull(_this__u8e3s4, defaultCharset);
  return tmp0_elvis_lhs == null ? defaultCharset : tmp0_elvis_lhs;
}
function Configuration$register$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function Configuration() {
}
function suitableCharsetOrNull(_this__u8e3s4, defaultCharset) {
  defaultCharset = defaultCharset === VOID ? Charsets_getInstance().n3n_1 : defaultCharset;
  var _iterator__ex2g4s = parseAndSortHeader(_this__u8e3s4.h2a(HttpHeaders_getInstance().c3x_1)).j();
  while (_iterator__ex2g4s.k()) {
    var charset = _iterator__ex2g4s.l().mf();
    if (charset === '*')
      return defaultCharset;
    else if (isSupported(Charsets_getInstance(), charset))
      return forName(Charsets_getInstance(), charset);
  }
  return null;
}
function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
  this.h4n_1 = function_0;
}
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).b1z = function (value, $completion) {
  return this.h4n_1(value, $completion);
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).k3 = function () {
  return this.h4n_1;
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, FlowCollector) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.k3(), other.k3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).hashCode = function () {
  return hashCode(this.k3());
};
function deserialize$o$collect$slambda($$this$unsafeFlow, $charset, $typeInfo, $body, resultContinuation) {
  this.q4n_1 = $$this$unsafeFlow;
  this.r4n_1 = $charset;
  this.s4n_1 = $typeInfo;
  this.t4n_1 = $body;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(deserialize$o$collect$slambda).y2a = function (value, $completion) {
  var tmp = this.z2a(value, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(deserialize$o$collect$slambda).h9 = function (p1, $completion) {
  return this.y2a((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
};
protoOf(deserialize$o$collect$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          var tmp_0 = this;
          tmp_0.v4n_1 = this.q4n_1;
          var tmp_1 = this;
          tmp_1.w4n_1 = this.u4n_1;
          this.x4n_1 = this.v4n_1;
          this.y4n_1 = this.w4n_1;
          var tmp_2 = this;
          tmp_2.z4n_1 = this.y4n_1;
          this.a4o_1 = this.z4n_1;
          this.n8_1 = 1;
          suspendResult = this.a4o_1.c4o(this.r4n_1, this.s4n_1, this.t4n_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.b4o_1 = suspendResult;
          this.n8_1 = 2;
          suspendResult = this.x4n_1.b1z(this.b4o_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          return Unit_instance;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(deserialize$o$collect$slambda).z2a = function (value, completion) {
  var i = new deserialize$o$collect$slambda(this.q4n_1, this.r4n_1, this.s4n_1, this.t4n_1, completion);
  i.u4n_1 = value;
  return i;
};
function deserialize$o$collect$slambda_0($$this$unsafeFlow, $charset, $typeInfo, $body, resultContinuation) {
  var i = new deserialize$o$collect$slambda($$this$unsafeFlow, $charset, $typeInfo, $body, resultContinuation);
  var l = function (value, $completion) {
    return i.y2a(value, $completion);
  };
  l.$arity = 1;
  return l;
}
function $collectCOROUTINE$1(_this__u8e3s4, collector, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.l4o_1 = _this__u8e3s4;
  this.m4o_1 = collector;
}
protoOf($collectCOROUTINE$1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          var tmp_0 = this;
          tmp_0.n4o_1 = this.m4o_1;
          this.o4o_1 = this.n4o_1;
          this.n8_1 = 1;
          var tmp_1 = deserialize$o$collect$slambda_0(this.o4o_1, this.l4o_1.q4o_1, this.l4o_1.r4o_1, this.l4o_1.s4o_1, null);
          suspendResult = this.l4o_1.p4o_1.h1y(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function deserialize$$inlined$map$1($this, $charset, $typeInfo, $body) {
  this.p4o_1 = $this;
  this.q4o_1 = $charset;
  this.r4o_1 = $typeInfo;
  this.s4o_1 = $body;
}
protoOf(deserialize$$inlined$map$1).c1z = function (collector, $completion) {
  var tmp = new $collectCOROUTINE$1(this, collector, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(deserialize$$inlined$map$1).h1y = function (collector, $completion) {
  return this.c1z(collector, $completion);
};
function deserialize$slambda($body, resultContinuation) {
  this.b4p_1 = $body;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(deserialize$slambda).d4p = function (it, $completion) {
  var tmp = this.z2a(it, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(deserialize$slambda).h9 = function (p1, $completion) {
  return this.d4p((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
};
protoOf(deserialize$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      if (tmp === 0) {
        this.o8_1 = 1;
        return !(this.c4p_1 == null) || this.b4p_1.x3d();
      } else if (tmp === 1) {
        throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      throw e;
    }
   while (true);
};
protoOf(deserialize$slambda).z2a = function (it, completion) {
  var i = new deserialize$slambda(this.b4p_1, completion);
  i.c4p_1 = it;
  return i;
};
function deserialize$slambda_0($body, resultContinuation) {
  var i = new deserialize$slambda($body, resultContinuation);
  var l = function (it, $completion) {
    return i.d4p(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function $deserializeCOROUTINE$0(_this__u8e3s4, body, typeInfo, charset, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.b4n_1 = _this__u8e3s4;
  this.c4n_1 = body;
  this.d4n_1 = typeInfo;
  this.e4n_1 = charset;
}
protoOf($deserializeCOROUTINE$0).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          var this_0 = asFlow(this.b4n_1);
          var tmp_0 = new deserialize$$inlined$map$1(this_0, this.e4n_1, this.d4n_1, this.c4n_1);
          suspendResult = firstOrNull(tmp_0, deserialize$slambda_0(this.c4n_1, null), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var result = suspendResult;
          var tmp_1;
          if (!(result == null)) {
            tmp_1 = result;
          } else {
            if (!this.c4n_1.x3d()) {
              tmp_1 = this.c4n_1;
            } else {
              var tmp0_safe_receiver = this.d4n_1.l3u_1;
              if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gb()) === true) {
                tmp_1 = NullBody_instance;
              } else {
                throw new ContentConvertException('No suitable converter found for ' + this.d4n_1.toString());
              }
            }
          }

          return tmp_1;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
//region block: exports
export {
  deserialize as deserialize17rec5pkkk30w,
  register$default as register$default2n93tkqtk1ptz,
  Configuration as Configuration20xgygxdzhlk5,
  JsonConvertException as JsonConvertExceptiongnc5x6xwaf77,
  suitableCharset as suitableCharset1jgdcpdzbzgzn,
};
//endregion

